import React from "react";
import { createScrollHandler } from "../../utils/scrollToSection";

const About = () => {
  const scrollToContact = createScrollHandler("contact");

  return (
    <section className="colorlib-about" data-section="about" id="about">
      <div className="colorlib-narrow-content">
        <div className="row">
          <div className="col-md-12">
            <div
              className="row row-bottom-padded-sm animate-box"
              data-animate-effect="fadeInLeft"
            >
              <div className="col-md-12">
                <div className="about-desc">
                  <span className="heading-meta">About</span>
                  <h2 className="colorlib-heading">Who Am I?</h2>
                  <p>
                    <strong>Hi, I’m Pradeep</strong> — a Senior Software
                    Engineer with 11+ years building mobile products. I lead
                    with <strong>native iOS</strong> (Swift, architecture, App
                    Store deployment and enterprise delivery) and use{" "}
                    <strong>Android</strong> or <strong>Flutter</strong> when
                    the product needs it. I also work across backend and{" "}
                    <strong>CI/CD</strong> so apps stay reliable after launch.
                  </p>
                  <p>
                    I have shipped 35+ applications for government, smart-city
                    parking, real estate, and research. That includes a reusable
                    iOS framework inside UMANG and ICARUS OPS — a checklist-based
                    operations app that reduces human error across aviation, data
                    centers, warehouses, and mining (offline sync cut from 30+
                    minutes to about 8–10), and enterprise Parklinq kiosks with{" "}
                    <strong>Stripe Tap to Pay</strong> and{" "}
                    <strong>JAMF MDM</strong>. I own the full path:
                    architecture, implementation, testing, release, and
                    production support — and I mentor other engineers along the
                    way.
                  </p>
                  <p>
                    I also hold AWS Cloud Practitioner, ISTQB CTFL, and PSM I.
                    AWS matters because my apps sit on APIs, storage, and CI/CD
                    — not only on the phone. ISTQB and Scrum cover how those
                    releases are tested and delivered.
                  </p>
                  <p>
                    Native iOS, cross-platform when it fits. If you need an app
                    that has to last — not just look good in a demo — that is
                    the work I do.
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div
                className="col-md-12 animate-box"
                data-animate-effect="fadeInLeft"
              >
                <div className="hire">
                  <h2>
                    I have shipped 35+ mobile applications
                    <br />
                    from App Store products to enterprise systems.
                  </h2>
                  <a
                    href="#contact"
                    className="btn-hire"
                    onClick={scrollToContact}
                  >
                    Hire me
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
